// extracted by mini-css-extract-plugin
export default {"container":"SelectInputGroup_container__ph3Fo","inputGroup":"SelectInputGroup_inputGroup__79Yc9","label":"SelectInputGroup_label__SNN0Y","error":"SelectInputGroup_error__eZff9"};